import React from "react";

export const PDFViewer = ({ url }: { url: string }) => {
  if (!url) {
    return <div>Документ не найден</div>;
  }
  return (
    <div className="h-[80vh]">
      <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="100%" height="100%" />
    </div>
  );
};
